var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("The page you are looking for isn't found")]),_c('p',[_vm._v("Please "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("go back")]),_vm._v(" and try your link again.")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }